import {
	NavigationMenuSchema,
	PrivacyPolicyPageSchema,
	ShippingPolicyPageSchema,
	TermsOfServicePageSchema,
	FaqPageSchema,
	GalleryPageSchema,
	HomePageSchema,
	ContactUsPageSchema,
	AboutWasticPageSchema,
	SustainableMovePageSchema,
} from './singletons';

import {
	LocalizedTextSchema,
	NavigationMenuItem,
	StaticPageSchema,
	FaqCategorySchema,
	FaqItemSchema,
	GalleryItemSchema,
	LocalizedBlockContent,
} from './objects';

export const singletonSchemas = [
	HomePageSchema,
	AboutWasticPageSchema,
	NavigationMenuSchema,
	ContactUsPageSchema,
	SustainableMovePageSchema,
	GalleryPageSchema,
	FaqPageSchema,
	TermsOfServicePageSchema,
	PrivacyPolicyPageSchema,
	ShippingPolicyPageSchema,
];

export const typesSchema = [
	NavigationMenuItem,
	StaticPageSchema,
	LocalizedTextSchema,
	FaqCategorySchema,
	FaqItemSchema,
	GalleryItemSchema,
	LocalizedBlockContent,
];

const SanitySchema = {
	types: [
		...singletonSchemas,
		...typesSchema,
	],
};

export default SanitySchema;